<sf-notification></sf-notification>

<div class="formgrid grid text-lg dashboard">

    <!-- Header Section -->
    <div class="surface-section col-12">
        <div class="flex flex-column lg:flex-row gap-3 justify-content-between lg:align-items-center border-primary p-3 w-full" style="border-top: 7px solid;">
            <div class="flex flex-column gap-2 col-12 md:col-12 lg:col-6">
                <div class="flex align-items-center gap-2">
                    <h1 class="m-0 font-semibold text-900 text-3xl line-height-3">Painel Administrativo</h1>
                </div>
                <p class="mb-0 mt-0 text-base text-600 text-lg">Visão completa do desempenho financeiro e operacional da empresa.</p>
            </div>
            <div class="flex gap-2 col-12 md:col-12 lg:col-6 justify-content-end">
                <button pButton pRipple label="Relatórios" icon="pi pi-chart-bar" class="p-button-outlined" (click)="navigateToReports()"></button>
                <button pButton pRipple label="Exportar" icon="pi pi-download" class="p-button-outlined"></button>
            </div>
        </div>
    </div>

    <!-- Billing KPIs -->
    <div class="col-12 mt-3">
        <div class="text-900 font-bold text-2xl mb-3">
            <i class="pi pi-dollar mr-2"></i>Indicadores de Faturamento
        </div>
    </div>

    <!-- Year Total -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer hover:border-primary transition-colors transition-duration-150" style="border-radius: 10px">
            <div class="flex align-items-center mb-3">
                <div class="mr-3">
                    <span class="inline-flex justify-content-center align-items-center bg-blue-100" style="border-radius: 8px; width:50px; height: 50px">
                        <i class="pi pi-calendar text-3xl text-blue-600"></i>
                    </span>
                </div>
                <span class="text-900 text-xl font-semibold">Faturamento Anual</span>
            </div>
            <div class="flex flex-column">
                <span class="text-blue-500 font-bold text-5xl mb-2">{{formatCurrency(billingKPI.yearTotal)}}</span>
                <div class="flex align-items-center">
                    <i class="pi pi-arrow-up text-green-500 mr-2"></i>
                    <span class="text-green-500 font-bold">+{{billingKPI.yearGrowth}}%</span>
                    <span class="text-500 ml-2">vs ano anterior</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Month Total -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer hover:border-primary transition-colors transition-duration-150" style="border-radius: 10px">
            <div class="flex align-items-center mb-3">
                <div class="mr-3">
                    <span class="inline-flex justify-content-center align-items-center bg-green-100" style="border-radius: 8px; width:50px; height: 50px">
                        <i class="pi pi-chart-line text-3xl text-green-600"></i>
                    </span>
                </div>
                <span class="text-900 text-xl font-semibold">Faturamento do Mês</span>
            </div>
            <div class="flex flex-column">
                <span class="text-green-500 font-bold text-5xl mb-2">{{formatCurrency(billingKPI.monthTotal)}}</span>
                <span class="text-500">Junho 2025</span>
            </div>
        </div>
    </div>

    <!-- Budget -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer hover:border-primary transition-colors transition-duration-150" style="border-radius: 10px">
            <div class="flex align-items-center mb-3">
                <div class="mr-3">
                    <span class="inline-flex justify-content-center align-items-center bg-purple-100" style="border-radius: 8px; width:50px; height: 50px">
                        <i class="pi pi-flag text-3xl text-purple-600"></i>
                    </span>
                </div>
                <span class="text-900 text-xl font-semibold">Meta Anual</span>
            </div>
            <div class="flex flex-column">
                <span class="text-purple-500 font-bold text-5xl mb-2">{{formatCurrency(billingKPI.budget)}}</span>
                <div class="flex justify-content-center mt-2">
                    <p-knob [(ngModel)]="billingKPI.budgetPercentage" valueColor="#9333EA" rangeColor="#E9D5FF" strokeWidth="12" size="80" valueTemplate="{value}%" [readonly]="true" />
                </div>
            </div>
        </div>
    </div>

    <!-- Monthly Average -->
    <div class="col-12 md:col-6 lg:col-3">
        <div class="shadow-2 surface-card p-4 border-2 border-transparent cursor-pointer hover:border-primary transition-colors transition-duration-150" style="border-radius: 10px">
            <div class="flex align-items-center mb-3">
                <div class="mr-3">
                    <span class="inline-flex justify-content-center align-items-center bg-orange-100" style="border-radius: 8px; width:50px; height: 50px">
                        <i class="pi pi-chart-bar text-3xl text-orange-600"></i>
                    </span>
                </div>
                <span class="text-900 text-xl font-semibold">Média Mensal</span>
            </div>
            <div class="flex flex-column">
                <span class="text-orange-500 font-bold text-5xl mb-2">{{formatCurrency(billingKPI.monthlyAverage)}}</span>
                <span class="text-500">Últimos 12 meses</span>
            </div>
        </div>
    </div>

    <!-- Revenue Chart -->
    <div class="col-12 lg:col-8 mt-3">
        <p-card header="Evolução do Faturamento" styleClass="shadow-2">
            <div style="height: 350px;">
                <p-chart type="line" [data]="revenueChartData" [options]="revenueChartOptions" height="350px"></p-chart>
            </div>
        </p-card>
    </div>

    <!-- Order Status Distribution -->
    <div class="col-12 lg:col-4 mt-3">
        <p-card header="Distribuição de Pedidos" styleClass="shadow-2">
            <p-chart type="doughnut" [data]="orderStatusChartData" [options]="orderStatusChartOptions"></p-chart>
            <div class="mt-4">
                <div *ngFor="let status of orderStatusData" class="flex align-items-center justify-content-between mb-3">
                    <div class="flex align-items-center">
                        <span class="inline-block w-1rem h-1rem border-round mr-2" [style.background-color]="status.color === 'green' ? '#22C55E' : status.color === 'blue' ? '#3B82F6' : status.color === 'orange' ? '#F97316' : '#EF4444'"></span>
                        <span class="text-900">{{status.status}}</span>
                    </div>
                    <span class="text-900 font-bold">{{status.count}}</span>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Team Performance Section -->
    <div class="col-12 mt-4">
        <div class="text-900 font-bold text-2xl mb-3">
            <i class="pi pi-users mr-2"></i>Desempenho da Equipe
        </div>
    </div>

    <!-- Employees Cards -->
    <div class="col-12 lg:col-8">
        <div class="surface-card shadow-2 border-round p-4">
            <div class="flex justify-content-between align-items-center mb-4">
                <span class="text-xl font-semibold text-900">Colaboradores</span>
                <button pButton pRipple label="Ver Todos" icon="pi pi-arrow-right" class="p-button-text" (click)="navigateToEmployees()"></button>
            </div>
            <p-scrollPanel [style]="{ width: '100%', height: screenHeight }">
                <div class="grid">
                    <div *ngFor="let employee of employees" class="col-12 mb-3">
                        <div class="border-1 border-200 border-round p-3 hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                            <div class="flex align-items-center justify-content-between">
                                <div class="flex align-items-center gap-3">
                                    <p-avatar
                                        [label]="employee.initials"
                                        size="large"
                                        [style]="{ 'background-color': '#42A5F5', 'color': 'white', 'font-weight': 'bold' }">
                                    </p-avatar>
                                    <div>
                                        <div class="flex align-items-center gap-2 mb-1">
                                            <span class="text-900 font-bold text-xl">{{employee.name}}</span>
                                            <i [class]="'pi ' + getStatusIcon(employee.status) + ' text-' + getStatusColor(employee.status) + '-500'"></i>
                                        </div>
                                        <span class="text-600">{{employee.role}}</span>
                                        <div class="mt-2">
                                            <p-rating [(ngModel)]="employee.rating" [readonly]="true" [cancel]="false"></p-rating>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex gap-4">
                                    <div class="text-center">
                                        <div class="text-500 text-sm mb-1">Produtividade</div>
                                        <p-knob [(ngModel)]="employee.productivity" valueColor="#42A5F5" rangeColor="#DBEAFE" strokeWidth="10" size="70" valueTemplate="{value}%" [readonly]="true" />
                                    </div>
                                    <div class="text-center">
                                        <div class="text-500 text-sm mb-1">Vendas</div>
                                        <div class="text-900 font-bold text-2xl">{{formatCurrency(employee.sales)}}</div>
                                        <div class="text-600 text-sm mt-1">{{employee.ordersCompleted}} pedidos</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
        </div>
    </div>

    <!-- Productivity Radar Chart -->
    <div class="col-12 lg:col-4">
        <p-card header="Produtividade da Equipe" styleClass="shadow-2">
            <p-chart type="radar" [data]="productivityChartData" [options]="productivityChartOptions"></p-chart>
            <div class="mt-4">
                <div class="flex align-items-center justify-content-between p-3 border-round bg-blue-50">
                    <span class="text-900 font-semibold">Média Geral</span>
                    <span class="text-blue-600 font-bold text-2xl">86.6%</span>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Team Performance Over Time -->
    <div class="col-12 mt-3">
        <p-card header="Desempenho Mensal da Equipe" styleClass="shadow-2">
            <div style="height: 350px;">
                <p-chart type="bar" [data]="teamPerformanceChartData" [options]="teamPerformanceChartOptions" height="350px"></p-chart>
            </div>

            <!-- Performance Summary Table -->
            <div class="mt-4">
                <p-table [value]="teamPerformance" styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Mês</th>
                            <th class="text-right">Pedidos</th>
                            <th class="text-right">Faturamento</th>
                            <th class="text-right">Tempo Médio (dias)</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td><span class="font-semibold">{{item.month}}</span></td>
                            <td class="text-right">
                                <span class="bg-blue-100 text-blue-900 px-2 py-1 border-round">{{item.orders}}</span>
                            </td>
                            <td class="text-right font-bold">{{formatCurrency(item.revenue)}}</td>
                            <td class="text-right">
                                <span [class]="item.avgTime < 4 ? 'text-green-600' : item.avgTime < 4.5 ? 'text-orange-600' : 'text-red-600'">
                                    {{item.avgTime}}
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>

</div>

